/*!

=========================================================
* Black Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  Form,
  Container,
  Col
} from "reactstrap";
import queryString from 'query-string';
import Request from '../../common/Request';

import GsuiteAuth from 'components/Auth/GsuiteAuth.jsx';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      errMessage: '',
      oauth_url: ''
    };

  }

  click = async () => {
    try {
      await GsuiteAuth.login(this.state.token);
      const DATA = localStorage.getItem("DATA") ? JSON.parse(localStorage.getItem("DATA") ): [] ;
      let pathname = DATA.filter((d,i)=>d["page_id"] == "A1_01").length > 0 ? "/construction/list" : "/blockmap/on_request";
      
      this.props.history.push({ pathname: pathname });
    } catch (e) {
      this.setState({ errMessage: '' });
    }
  };
  componentDidMount() {
    document.body.classList.toggle("login-page");

    let params = queryString.parse(this.props.location.search);
    if (params && params.code) {
      Request.post('/api/login', {
        code: params.code
      },
        (res) => {
          GsuiteAuth.set('isLoggedIn', true);
          GsuiteAuth.set('name', res.Data.name || "");
          GsuiteAuth.set('picture', res.Data.picture || "");
          GsuiteAuth.set('token', res.Data.token);
          GsuiteAuth.set('division_name', res.Data.division_name || "");
          GsuiteAuth.set('employee_type', res.Data.employee_type || "");
          GsuiteAuth.set('id', res.Data.id);
          GsuiteAuth.set('is_active', res.Data.is_active);
          GsuiteAuth.set('is_staff', res.Data.is_staff);
          GsuiteAuth.set('first_name', res.Data.first_name || "");
          GsuiteAuth.set('last_name', res.Data.last_name || "");
          GsuiteAuth.set('email', res.Data.email || "");
          GsuiteAuth.set('user_tel', res.Data.user_tel || "");
          GsuiteAuth.set('user_cc_email', res.Data.user_cc_email || "");
          GsuiteAuth.set('user_branch_id', res.Data.user_branch_id);
          GsuiteAuth.set('user_branch_natural_id', res.Data.user_branch_natural_id);
          GsuiteAuth.set('user_branch_name', res.Data.user_branch_name || "");
          GsuiteAuth.set('user_branch_zip_code', res.Data.user_branch_zip_code || "");
          GsuiteAuth.set('user_branch_prefecture', res.Data.user_branch_prefecture || "");
          GsuiteAuth.set('user_branch_city', res.Data.user_branch_city || "");
          GsuiteAuth.set('user_branch_address', res.Data.user_branch_address || "");
          GsuiteAuth.set('user_branch_tel', res.Data.user_branch_tel || "");
          GsuiteAuth.set('user_branch_fax', res.Data.user_branch_fax || "");
          GsuiteAuth.set('user_branch_deposit_bank_account', res.Data.user_branch_deposit_bank_account || "");
          GsuiteAuth.set('___JOIN_user_branch_address', res.Data.___JOIN_user_branch_address || "");
          GsuiteAuth.set('DATA', res.Data.DATA);
          GsuiteAuth.set('BUTTONS', res.Data.BUTTONS);
          
          console.log(res.Data)

          const DATA = localStorage.getItem("DATA") ? JSON.parse(localStorage.getItem("DATA") ): [] ;
          let pathname = DATA.filter((d,i)=>d["page_id"] == "A1_01").length > 0 ? "/construction/list" : "/blockmap/on_request";
    
          this.props.history.push({ pathname: pathname });
        },
        () => {}, () => {}, false, false);
    }
    Request.get('/api/oauth_url', {}, (res) => {
      this.setState({ oauth_url: res.data.url })
    }, () => {}, () => {}, false, false);
  }
  componentWillUnmount() {
    document.body.classList.toggle("login-page");
  }
  render() {
    return (
      <>
        <div className="content">
          <Container>
            <Col className="ml-auto mr-auto" lg="4" md="6">
              <Form className="form">
                <Card className="card-login card-white">
                  <CardHeader>
                    <CardTitle tag="h1">LANDMARK</CardTitle>
                  </CardHeader>
                  <CardFooter>
                    {this.state.oauth_url && 
                    <>
                    <Button
                      block
                      className="mb-3"
                      href={this.state.oauth_url}
                      size="lg"
                    >
                      ログイン
                    </Button>
                    </>
                    }
                    {/*this.state.oauth_url &&
                      <>
                        <br /><br />
                        <a href={this.state.oauth_url}>oauth test</a>
                      </>
                    */}
                  </CardFooter>
                </Card>
              </Form>
            </Col>
          </Container>
        </div>
      </>
    );
  }
}

export default Login;
